import { Link } from "react-router-dom";
import { ShoppingBag, ChevronRight } from "lucide-react";
import { useApp } from "@/store/AppContext";
import { inr } from "@/lib/api";

export function StickyCart() {
  const { cart, cartCount } = useApp();
  if (!cartCount) return null;
  return (
    <div className="fixed md:hidden left-3 right-3 z-40 rise flex gap-2" style={{ bottom: "calc(env(safe-area-inset-bottom) + 72px)" }} data-testid="sticky-cart">
      <Link to="/cart" className="flex items-center gap-2 rounded-2xl bg-white border border-[var(--brand-tertiary)] text-[var(--brand)] px-3 py-3 shadow-lg" data-testid="sticky-cart-view">
        <div className="flex -space-x-2">{cart.items.slice(0, 2).map((i) => <img key={i.id} src={i.image} alt="" className="w-8 h-8 rounded-full border-2 border-white object-cover" />)}</div>
        <div className="leading-tight"><p className="text-[11px] opacity-80">{cartCount} item{cartCount > 1 ? "s" : ""}</p><p className="font-bold text-sm">{inr(cart.total)}</p></div>
      </Link>
      <Link to="/checkout" className="flex-1 flex items-center justify-center gap-2 rounded-2xl bg-[var(--brand-primary)] text-white px-4 py-3 font-bold shadow-[0_10px_30px_rgba(22,115,63,0.4)]" data-testid="sticky-cart-checkout"><ShoppingBag size={18} /> Checkout <ChevronRight size={18} /></Link>
    </div>
  );
}
